export function formatCredits(milli: number): string {
  return (Math.round(milli / 100) / 10).toLocaleString('en-US');
}

export function timeAgo(iso: string | null, now: Date): string {
  if (!iso) return 'never';
  const mins = Math.max(0, Math.floor((now.getTime() - new Date(iso).getTime()) / 60_000));
  if (mins < 60) return `${mins}m ago`;
  const hours = Math.floor(mins / 60);
  if (hours < 48) return `${hours}h ago`;
  return `${Math.floor(hours / 24)}d ago`;
}
